export default __webpack_public_path__ + "static/media/record.993f1f21.png";